import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../PromoHero.css';

export default function PromoHero() {
    const [currentSlide, setCurrentSlide] = useState(0);
    
    // Images stored in public/images/promo folder
    const slides = [
        process.env.PUBLIC_URL + '/images/promo/promo-banner-1.png',
        process.env.PUBLIC_URL + '/images/promo/promo-banner-2.png'
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 4000); // Auto-scroll every 4 seconds

        return () => clearInterval(interval);
    }, [slides.length]);

    return (
        <>
            {/* White Divider */}
            <div className="promo-divider"></div>
            
            <div className="promo-hero-section">
                <div className="promo-hero-container">
                    {/* Left Side - Image Carousel */}
                    <div className="promo-carousel-side">
                        <div className="promo-carousel">
                            <div 
                                className="promo-slides-container" 
                                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                            >
                                {slides.map((slide, index) => (
                                    <div className="promo-slide" key={index}>
                                        <img src={slide} alt={`Promo Banner ${index + 1}`} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Right Side - Text Content */}
                    <div className="promo-content-side">
                        <div className="promo-text-content">
                            <h2 className="promo-heading">
                                Get <span className="highlight-yellow">20% to 30%</span> OFF
                            </h2>
                            <p className="promo-subtext">On All International Parcels!</p>
                            <p className="promo-description">
                                Limited time offer for new wallet users. Top up your wallet and start saving instantly!
                            </p>
                            <Link to="/contact-sales" className="promo-cta-btn">
                                Contact Sales Now
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Bottom Divider */}
            <div className="promo-divider-bottom"></div>
        </>
    );
}
